module.exports = __webpack_public_path__ + "static/media/disabled-excel.08bd5828.svg";